import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { publicAPI } from '../../lib/api';
import { MapPin, Search } from 'lucide-react';
import { Input } from '../../components/ui/input';

export default function CitiesPage() {
  const [cities, setCities] = useState([]);
  const [search, setSearch] = useState('');
  const [filtered, setFiltered] = useState([]);

  useEffect(() => {
    publicAPI.getCities().then(r => {
      setCities(r.data);
      setFiltered(r.data);
    });
  }, []);

  useEffect(() => {
    if (search) {
      setFiltered(cities.filter(c => c.name.toLowerCase().includes(search.toLowerCase())));
    } else {
      setFiltered(cities);
    }
  }, [search, cities]);

  return (
    <>
      <Helmet>
        <title>Hizmet Verilen Sehirler | 81 Il</title>
        <meta name="description" content="Turkiye genelinde 81 ilde endustriyel uretim hizmetleri icin teklif alin." />
      </Helmet>

      <section className="bg-slate-50 py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl font-semibold mb-4" data-testid="cities-title">Hizmet Verilen Sehirler</h1>
          <p className="text-muted-foreground mb-6">Turkiye genelinde 81 ilde endustriyel uretim hizmetleri sunuyoruz.</p>
          <div className="relative max-w-md">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input
              placeholder="Sehir ara..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="pl-10"
              data-testid="city-search"
            />
          </div>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
            {filtered.map(c => (
              <Link
                key={c.id}
                to={`/${c.slug}`}
                className="flex items-center gap-2 p-3 rounded-lg border bg-white hover:border-slate-300 hover:shadow-sm transition-all"
                data-testid={`city-${c.slug}`}
              >
                <MapPin className="h-4 w-4 text-[hsl(221,83%,22%)] flex-shrink-0" />
                <span className="text-sm font-medium">{c.name}</span>
              </Link>
            ))}
          </div>
          {filtered.length === 0 && (
            <p className="text-center text-muted-foreground py-12">Sonuc bulunamadi.</p>
          )}
        </div>
      </section>
    </>
  );
}
